import { FC, PropsWithChildren } from 'react';
import { cn, SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';
import { ScrollArea } from '@ibsys/kit';

type Props = PropsWithChildren<{
  className?: string;
  outerClassName?: string;
  enableScroll?: boolean;
  limitedWidth?: boolean;
}>;

export const PageContainer: FC<Props> = ({
  className,
  children,
  outerClassName,
  enableScroll = true,
  limitedWidth = true,
}) => {
  const content = (
    <div className={cn('p-2 md:p-8 flex flex-col w-full h-full', outerClassName)}>
      <div className={cn(limitedWidth && 'max-w-7xl mx-auto w-full', 'h-full', className)}>{children}</div>
    </div>
  );

  if (!enableScroll) {
    return content;
  }

  return <ScrollArea className={cn('h-full', SCROLL_AREA_VIEWPORT_BLOCK)}>{content}</ScrollArea>;
};
